import React,{ useRef, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import SkillCard from './SkillCard';
import ButtonComp from './ButtonComp';
import ReactHtmlParser from 'react-html-parser';
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";

const SkillAreas = ({skillAreaTitle,skillSubtitle,skillBottomBoldtitle,TopMiddleSection,lifestyleCards,background,color,btnText,className,leftSection=true,skillBottomtitle,btnText2,btnLink2,MiddleInfoSection,highlitedBackground,btnLink="/auth/register",skillToptitle,img,sliders=4.5,center="",skillCardClass,noTilt=false,padding="",cardClass="",bottomListNew=[],italic=false,headerCenter=false,barWidth=""}) => {
  const scrollRef = useRef(null);
  const [activeVideo, setActiveVideo] = useState(null);
skillBottomBoldtitle
  useEffect(() => {
    const slider = scrollRef.current;
    if (!slider) return;
    let isDown = false;
    let startX;
    let scrollLeft;

    const handleMouseDown = (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    };

    const handleMouseLeave = () => {
      isDown = false;
      slider.classList.remove("active");
    };

    const handleMouseUp = () => {
      isDown = false;
      slider.classList.remove("active");
    };

    const handleMouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2; // scroll speed
      slider.scrollLeft = scrollLeft - walk;
    };

    // Touch support
    const handleTouchStart = (e) => {
      startX = e.touches[0].pageX;
      scrollLeft = slider.scrollLeft;
    };

    const handleTouchMove = (e) => {
      const x = e.touches[0].pageX;
      const walk = (x - startX) * 2;
      slider.scrollLeft = scrollLeft - walk;
    };

    slider.addEventListener("mousedown", handleMouseDown);
    slider.addEventListener("mouseleave", handleMouseLeave);
    slider.addEventListener("mouseup", handleMouseUp);
    slider.addEventListener("mousemove", handleMouseMove);

    slider.addEventListener("touchstart", handleTouchStart);
    slider.addEventListener("touchmove", handleTouchMove);

    return () => {
      slider.removeEventListener("mousedown", handleMouseDown);
      slider.removeEventListener("mouseleave", handleMouseLeave);
      slider.removeEventListener("mouseup", handleMouseUp);
      slider.removeEventListener("mousemove", handleMouseMove);

      slider.removeEventListener("touchstart", handleTouchStart);
      slider.removeEventListener("touchmove", handleTouchMove);
    };
  }, []);
  

  return (
   <>
    <div className={`why-choosing-skill np-busy-lifestyle ${className} ${noTilt ? `no-tilt ${padding}` : ""} py-5`} id='skill-area'
    style={{
        background:`${background ? background : "linear-gradient(180deg, #0D1830 29.33%, #0D1830 64.9%, #7F56D9 100%)"}`,
        color:`${color ? color : "white"}`
    }}
    >
         <div className="custom-container">
       
           {/* HEADER */}
           {/* <div className="row align-items-center mb-5"> */}
           <div className={`d-flex w-100 gap-4 ${headerCenter ? "flex-column text-center mb-3" : "flex-column flex-lg-row justify-content-between align-items-center"}`}>
              <div className={leftSection ? "w-100 w-lg-50" : `w-100 ${center ? center : ""}`}> {skillAreaTitle && skillAreaTitle()}
            </div> 
            {
              leftSection && (
              <div className="w-100 w-lg-40 d-flex flex-column gap-3">
              { skillSubtitle && <p className={`skill-title sub-title FS16FW500 fw-400 ${color ? color : "white"}`}>
                  {ReactHtmlParser(skillSubtitle)}
                </p>
               }
               { highlitedBackground && <div className='academy-highlight-box FS16FW500 mt-3 mb-4' >{highlitedBackground}</div> }
              {btnText &&  <ButtonComp className="mt-4" link={btnLink} btnText={btnText} img={img}/>}
             </div> 
              )
            }
         
           </div> 

            {skillToptitle && 
             <div className="align-items-center d-flex flex-column gap-4 FS16FW500 my-4">
               <p className={`skill-title sub-title ${color ? color : "white"}`}>
                 {skillToptitle}
               </p>
              </div>
            }
           {TopMiddleSection && TopMiddleSection()}
       
           {/* CARDS */}
           {lifestyleCards.length <= 4 ? (
           <div className="row flex-nowrap overflow-auto g-4 scroll-row py-3">
             {lifestyleCards.map((card, index) => (
              <div className={`${skillCardClass ? skillCardClass : "col-md-6 col-lg-3 d-flex"}`} key={index}>
                <SkillCard card={card} index={index} color={color} noTilt={noTilt} onClick={card.videoUrl ? () => setActiveVideo(card) : undefined} cardClass={cardClass}/>
              </div>
             ))}       
           </div>
           ):(
           <Swiper
              modules={[FreeMode]}
              spaceBetween={16}
              slidesPerView={sliders}
              grabCursor={true}
              freeMode={true}
              breakpoints={{
                1400: { slidesPerView: sliders },
                1200: { slidesPerView: 3.5 },
                992: { slidesPerView: 2.8 },
                768: { slidesPerView: 2.2 },
                576: { slidesPerView: 1.5 },
                0: { slidesPerView: 1.2 },
              }}
              className='py-3'
            >
              {lifestyleCards.map((card, index) => (
                <SwiperSlide key={card.id || index}>
                  <div className='col-12 d-flex lifestyle-card' >
                  <SkillCard card={card} index={index} color={color} noTilt={noTilt} onClick={card.videoUrl ? () => setActiveVideo(card) : undefined} cardClass={cardClass}/>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
           )}
           {MiddleInfoSection && (
              <div className={`row g-3 mt-3 plus-sans FS16FW500 fw-400 justify-content-${MiddleInfoSection.length === 1 ? 'center':'between'}`}>
                {MiddleInfoSection.map((item, i) => {
                  const isSingle = MiddleInfoSection.length === 1;

                  return (
                    <div
                      key={i}
                      className={`
                        ${isSingle ? `col-10 text-center ${barWidth}` : "col-lg-5 col-md-6"} 
                        feature-card-skillToptitle
                      `}
                    >
                      <div className="h-100" dangerouslySetInnerHTML={{ __html: item }}/>
                    </div>
                  );
                })}
              </div>
            )}
         <div className="align-items-center d-flex flex-column gap-4 FS16FW500 mt-4">
            {(skillBottomtitle && !italic) ? <p className={`skill-title sub-title ${color ? color : "white"}`}>
              {skillBottomtitle}
            </p> :
              <p className="quote-para FS18FW400 fw-700 text-center">
                <em>{skillBottomtitle}</em>
              </p>}
            {skillBottomBoldtitle && (
              <h5 className={`FS24FW500 fw-700 plus-sans`}>
                {skillBottomBoldtitle}
              </h5>
            )}
          {bottomListNew.length > 0 && <ul className={`d-flex feature-list gap-4 justify-content-between w-100`} >
                  {bottomListNew.map((item, i) => (
                    <li
                      key={i}
                      className={`feature-item plus-sans`}
                    >
                        <div>
                          <h6 className="fw-700 FS18FW400 mb-2">
                            {item.title}
                          </h6>

                          <span className="FS16FW500 fw-400">
                            {item.desc}
                          </span>
                        </div>
                    </li>
                  ))}
                </ul>
              }

              {btnText2 &&  <ButtonComp className="mt-4" link={btnLink2 || "/auth/register"} btnText={btnText2} img={img}/>}
          </div>
          </div>
         </div>

      <Modal show={!!activeVideo} size="lg" className="modal-dialog-centered" modalClassName="dashboard-video-popup">
        <div className="modal-header d-flex justify-content-between">
          <h5 className="modal-title FS16FW500">{activeVideo?.title}</h5>
          <button type="button" className="btn-close" aria-label="Close" onClick={() => setActiveVideo(null)}/>
        </div>
        <Modal.Body className="d-flex align-items-center justify-content-center flex-column">
          {activeVideo && (
            <iframe
              className="dashboard-popup-video"
              src={`https://www.youtube.com/embed/${activeVideo?.videoUrl}?autoplay=1`}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              frameBorder="0"
              style={{width:'clamp(258px, 60vw, 610px)', height:'clamp(120px, 35vw, 330px)'}}
            />
          )}
        </Modal.Body>
      </Modal>
   </>
  )
}

export default SkillAreas
